import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import RoyaltyForm from './forms/RoyaltyForm';
import RoyaltyList from './lists/RoyaltyList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import RoyaltyRangeEditor from "./RoyaltyRangeEditor";
import ModalEditor from "./ModalEditor";
import connect from "react-redux/es/connect/connect";

class RoyaltyEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        if (!this.props.pos) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Jogdíjak"
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.isLoading}
                        color="default"
                        onClick={this.pristineForm}
                    >
                        Új
                    </Button>
                ]}
            >
                <RoyaltyList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Jogdíj"
                footer={[
                    <Button
                        key="0"
                        disabled={!this.props.dirty || this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>,
                    <Button
                        key="1"
                        disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        color="danger"
                        className="pull-left"
                        onClick={this.deleteForm}
                    >
                        Törlés
                    </Button>
                ]}
            >
                <RoyaltyForm {...this.props} />
            </Editor>
            {this.props.values[this.props.componentConfig.idfield] && <RoyaltyRangeEditor
                editorContext="RoyaltyRoyaltyRangeEditor"
                presets={{royalty: this.props.values[this.props.componentConfig.idfield]}}
                editor={ModalEditor}
                selection={null}
                listFilter={{
                    field: "royalty",
                    value: this.props.values[this.props.componentConfig.idfield]
                }}
            />}
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos
    };
}, {})(createEditor({
    componentName: "Royalty",
    WrappedComponent: RoyaltyEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            delete data.object_component;
            return {action,data,params};
        }
    }
}));
